import { Col, Form, InputNumber, Row, Switch, TimePicker } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ExamGroup } from "@types";

interface Props {
  examGroup: ExamGroup;
  form?: any; // Dodajte form prop
}

export const QuestionsByOrder = ({ examGroup, form }: Props) => {
  const { t } = useTranslation();
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [showPercentage, setShowPercentage] = useState(false);

  const disabledTime = () => ({
    disabledMinutes: () => [0],
    disabledSeconds: () => [0],
  });

  useEffect(() => {
    if (examGroup) {
      setShowPercentage(examGroup.percentageToPass !== null);
      setShowTimePicker(examGroup.timeInSeconds !== null);
    }
  }, [examGroup]);

  // Dodajte useEffect za praćenje promena switch-ova
  useEffect(() => {
    if (form) {
      if (!showTimePicker) {
        form.setFieldValue(['timeInSeconds'], null);
      }
      if (!showPercentage) {
        form.setFieldValue(['percentageToPass'], null);
      }
    }
  }, [showTimePicker, showPercentage, form]);

  const handleTimeRestrictionChange = (val: boolean) => {
    setShowTimePicker(val);
    if (!val && form) {
      form.setFieldValue(['timeInSeconds'], null);
    }
  };

  const handlePercentageChange = (val: boolean) => {
    setShowPercentage(val);
    if (!val && form) {
      form.setFieldValue(['percentageToPass'], null);
    }
  };

  return (
    <>
      <Row>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item
            name={["timeRestriction"]}
            valuePropName="checked"
            label={t("forms.questionGroup.timeRestriction")}
          >
            <Switch onChange={(val) => handleTimeRestrictionChange(val)} />
          </Form.Item>
        </Col>
        {showTimePicker ? (
          <Col lg={12} md={24} sm={24} xs={24}>
            <Form.Item name={["timeInSeconds"]} label={t("forms.questionGroup.minutes")}>
              <TimePicker needConfirm={false} showNow={false} format={"m [min]"} disabledTime={disabledTime} />
            </Form.Item>
          </Col>
        ) : (
          <></>
        )}
      </Row>

      <Row>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item
            valuePropName="checked"
            name={["percentage"]}
            label={t("forms.questionGroup.percentageGroup")}
          >
            <Switch onChange={(val) => handlePercentageChange(val)} />
          </Form.Item>
        </Col>
        <Col lg={12} md={24} sm={24} xs={24}>
          <Form.Item
            name={["percentageToPass"]}
            label={showPercentage ? t("forms.questionGroup.percentage") : ""}
            style={{ display: showPercentage ? 'block' : 'none' }}
          >
            <InputNumber suffix="%" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};